module.exports = __webpack_public_path__ + "images/header-loading-logo.d73159084f5122775d4d.gif";


//////////////////
// WEBPACK FOOTER
// ./resources/images/header-loading-logo.gif
// module id = AgJc
// module chunks = 24